export { DMS_MODULE } from '@/modules/ciselnik/constants';
export const CRUMB_LABEL_KEY = <const>'edtFakturaceProfil';
export const NAME = <const>'FakturacniProfil';


export const apiFunctionNames = <const>{
	copyFakturaceProfilAll: 'copyFakturaceProfilAll',
	copyFakturaceProfilHodSzbNahr: 'copyFakturaceProfilHodSzbNahr',
	copyFakturaceProfilNdPcNahr: 'copyFakturaceProfilNdPcNahr',
	copyFakturaceProfilLakSzbNahr: 'copyFakturaceProfilLakSzbNahr',
};
